import { Accordion, AccordionDetails, AccordionSummary, Fade, Grid, makeStyles, Modal } from "@material-ui/core";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { campaignService } from "../services/campaigns.service";
import { InstyleButton, InstyleFloatingActionButton, InstyleFloatingSaveButton, LedBox } from "../components/Page/Page";
import AddIcon from '@material-ui/icons/Add';
import NewCampaign from "../components/Campaigns/NewCampaign";
import { getAllAreas } from "../store/slices/salesAreaSlice";
import { getAllSources } from "../store/slices/leadSourceSlice";
import { getAllCampaigns, getAllRuleTypes, loadCampaigns, loadRuleTypes } from "../store/slices/campaignSlice";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

export const CampaignPath = "/campaigns"

const modalStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const listStyles = makeStyles((theme) => ({
  hoverUpStyle: {
    color: '#000',
    '&:hover': { color: 'green !important' },
  },
  hoverDownStyle: {
    color: '#000',
    '&:hover': { color: 'red !important' },
  }
}));

function Campaigns() {
    const dispatch = useDispatch();
    const salesAreas = useSelector(getAllAreas);
    const leadSources = useSelector(getAllSources);
    const campaigns = useSelector(getAllCampaigns);
    const ruleTypes = useSelector(getAllRuleTypes);
    const classes = modalStyles();
    const arrowClasses = listStyles();
    const [fetchData, setFetchData] = React.useState(true);
    const [modalOpen, setModal] = React.useState(false);
    const [selectedCampaign, setSelectedCampaign] = React.useState(null)
    const [disablePriorityButton, setDisablePriority] = React.useState(true);


    //fetch a heap of data regarding campaigns
    //need rule_types and campaigns
    useEffect(() => {
        campaignService.getRuleTypes().then(resp => {
            if (resp.Success) {
                if (resp.Data.Campaigns.length > 0) {
                    resp.Data.Campaigns.forEach((c, i) => {
                        resp.Data.Campaigns[i].Rules.forEach((r, ix) => {
                            resp.Data.Campaigns[i].Rules[ix].Values = resp.Data.Campaigns[i].Rules[ix].Values.split(",")
                        })
                        if (resp.Data.Campaigns[i].Priority === 0) {
                            console.log("setting priorities!" + (i + 1))
                            resp.Data.Campaigns[i].Priority = i + 1;
                        }
                    })
                    dispatch(loadCampaigns(resp.Data.Campaigns));
                }
                if (resp.Data.RuleTypes.length > 0) {
                    dispatch(loadRuleTypes(resp.Data.RuleTypes));
                }
            }
        })
        .catch(err => {
            console.error(err)
        })
    }, [fetchData]);

    //If a campaign is saved, fetch some new data
    const hasSavedCampaign = () => {
        setModal(false);
        setFetchData(!fetchData);
    }

    const closeModal = () => {
        setSelectedCampaign(null)
        setModal(false);
    }

    const editCampaign = (campaign) => {
        setSelectedCampaign(campaign);
    }

    useEffect(() => {
        if (selectedCampaign) {
            setModal(true);
        }
    }, [selectedCampaign])

    const displayRuleValues = (type, val) => {
        const rt = ruleTypes.find(rt => rt.ID === parseInt(type));
        if (!rt) {
            //rule type was not found :(, return a string
            return val.join(",")
        }
        let str = [];
        switch(rt.Name) {
            case "Sales Area":
                //lookup the sales areas and use the label
                if (typeof val === 'string') {
                    val = val.split(',')
                }
                str = val.map(id => {
                    let sa = salesAreas.find(s => s.ID === parseInt(id));
                    return sa ? sa.Label : '';
                })
                return str.join(", ")
            case "Rebirth Count":
                if (typeof val === 'string') {
                    return val;
                }
                return val.join(",");
            case "Lead Source":
                if (typeof val === 'string') {
                    val = val.split(",");
                }
                str = val.map(id => {
                    let ls = leadSources.find(l => l.ID === parseInt(id));
                    return ls ? ls.Label : id;
                })
                return str.join(",")
                case "Date Created":
                    return "After " + val + " days ago."
            default:
                console.log("Unknown type found: " + rt.Name)
                if (typeof val !== 'string') {
                    return val.join(',');
                }
                return val;
        }
    }

    const displayRuleType = (val) => {
        const rt = ruleTypes.find(rt => rt.ID === parseInt(val));
        return rt ? rt.Name : "Unknown Rule Type";
    }

    const reorderCampaigns = (cid, direction) => {
        let c = campaigns.findIndex(c => c.ID === cid)
        console.log(`moving campaign from index ${c} to ${c + direction}`);
        let newArr = JSON.parse(JSON.stringify(campaigns))
        //put whatever item is in the destination into the current location
        //put the current campaign into the new location
        let old = newArr[c];
        newArr[c] = newArr[c + direction];
        newArr[c+direction] = old;
        newArr = newArr.map((a, ix) => {
            a.Priority = ix + 1;
            return a;
        })
        setDisablePriority(false);
        dispatch(loadCampaigns(newArr));
    }

    const saveOrder = () => {
        setDisablePriority(true)
        campaignService.saveOrder(campaigns).then(resp => {
            if (resp.Success) {
                console.log("Saved campaign priority")
            } else {
                setDisablePriority(false);
            }
        }).catch(err => {
            console.error(err);
            setDisablePriority(false);
        })
    }

    return(
        <>
            <Grid container style={{overflow: "scroll", height: "100%", width: "100%", position: "relative", overflow: "scroll"}}>
                <Grid item xs={12} style={{textAlign: "center"}}>
                    <h1 style={{fontFamily: "Ink", marginTop: ".2em"}}>Campaigns</h1>
                </Grid>
                <Grid item xs={2} style={{textAlign: "center"}}>
                    <InstyleButton disabled={disablePriorityButton} onClick={saveOrder}>Save Order</InstyleButton>
                </Grid>
                <Grid item xs={12}>
                    {
                    campaigns.map((c, cix) => {
                        return (
                            <>
                            <div key={`campaign-list-${c.ID}`} style={{display: "flex", alignItems: "center"}}>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <div className={arrowClasses.hoverUpStyle} onClick={() => reorderCampaigns(c.ID, -1)}>{ cix != 0 && <ArrowUpwardIcon /> }</div>
                                    <div className={arrowClasses.hoverDownStyle} onClick={() => reorderCampaigns(c.ID, 1)}>{ cix != campaigns.length -1 && <ArrowDownwardIcon /> }</div>
                                </div>

                                <Accordion style={{flexGrow: 1, border: "1px solid black", marginLeft: "10px", marginRight: "10px"}}>
                                    <AccordionSummary>
                                        <div style={{display: "flex", width: "100%"}}>
                                            <div style={{flexGrow: "1"}}>{c.Name}</div>
                                            <LedBox>
                                                <div className={c.Active ? 'led-green' : 'led-red'}></div>
                                            </LedBox>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails style={{flexDirection: "column", flexWrap: "wrap", paddingBottom: "75px"}}>
                                        {
                                            c.Rules.map((r, i) => {
                                                return (
                                                    <div key={`${c.ID}-info-${i}`} style={{display: "flex", flexDirection: "row", flexWrap: "no-wrap"}}>
                                                        <span style={{width: "33%"}}>#{i + 1}</span>
                                                        <span style={{width: "33%"}}>Rule Type: {displayRuleType(r.TypeID)}</span>
                                                        <span style={{width: "33%"}}>Rule Values: {displayRuleValues(r.TypeID, r.Values)}</span>
                                                    </div>
                                                )
                                            })
                                        }
                                        <InstyleFloatingSaveButton onClick={() => editCampaign(c)}>Edit</InstyleFloatingSaveButton>
                                    </AccordionDetails>
                                </Accordion>
                                </div>
                            </>
                        )
                    })
                }
                </Grid>
                <InstyleFloatingActionButton onClick={() => setModal(true)}><AddIcon/></InstyleFloatingActionButton>
            </Grid>
            <Modal
            open={modalOpen}
            className={classes.modal}
            onClose={closeModal}
            >
                <Fade in={modalOpen}>
                    <NewCampaign CampaignLength={campaigns.length} Campaign={selectedCampaign} onSaveHandler={hasSavedCampaign} ruleTypes={ruleTypes} />
                </Fade>
            </Modal>
        </>
    )
}

export default Campaigns;